export interface BoostTask {
  id: string | number;
  title?: string;
  description?: string;
  icon?: string;
  provider: string;
  link?: string;
  onClick: () => Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  onShowReward?: () => Promise<boolean>;
}

export interface BoostProvider {
  getName(): string;
  getAvailableTasks(): Promise<BoostTask[]>;
  startTask?(
    taskId: string | number,
  ): Promise<'success' | 'user_cancelled' | 'ads_not_found'>;
  resetError?(): void;
}
interface ProviderEntry {
  provider: BoostProvider;
  priority: number;
}
export class TasksManager {
  private static providers: ProviderEntry[] = [];

  static registerProvider(provider: BoostProvider, priority: number) {
    this.providers.push({ provider, priority });
    this.providers.sort((a, b) => b.priority - a.priority);
  }

  static getProviders(): BoostProvider[] {
    return this.providers.map((entry) => entry.provider);
  }

  static async showAd(): Promise<boolean> {
    for (const { provider } of this.providers) {
      try {
        const tasks = await provider.getAvailableTasks();
        if (tasks.length > 0) {
          console.log(
            `Пытаемся показать рекламу через провайдера: ${provider.getName()}`,
          );
          const result = await tasks[0].onClick();
          return Boolean(result);
        }
      } catch (error) {
        console.error(
          `Ошибка при показе рекламы через ${provider.getName()}:`,
          error,
        );
      }
    }
    return false;
  }
}
